<template>
    <!-- Composant qui gère les réglages de couleurs du module.  -->

    <div v-if="embedded" class="tenjityModule-item tenjityModule-item-colors-submenu"
        style="height: auto; overflow: visible;">
        <div class="tenjityModule-item" v-for="filter in filtersData" :key="filter.filterType"
            @click="toggleFilter(filter)" :class="{ 'tenjityModule-item-active': isActiveFilter(filter.name) }">
            <div class="tenjityModule-item-header">
                <Icon class="tenjityModule-item-icon tenjityModule-item-icon-filter" :icon="filter.icon" />
                <div class="tenjityModule-item-name-small" role="button">{{ filter.name }}</div>
                <div class="tenjityModule-item-right"></div>
            </div>
            <div class="tenjityModule-item-btns">
                <AccessibilityBtn type="minus" @handleClick="changeFilterValue(filter, 'minus')"
                    :isDisabled="filter.value === filter.min" />
                <AccessibilityInput :label="filter.name" :min="filter.min" :max="filter.max" :unit="filter.unit"
                    @handleClickInput="checkToggleFilter(filter)" v-model:inputValue="filter.value" />
                <AccessibilityBtn type="more" @handleClick="changeFilterValue(filter, 'more')"
                    :isDisabled="filter.value === filter.max" />
            </div>
        </div>
    </div>
    <div v-else class="tenjityModule-section" :class="{ 'tenjityModule-section-active': isSectionActive }">
        <AccessibilitySectionHeader :isSectionActive="isSectionActive" :title="title" @handleClickReset="resetData"
            @handleClickExpand="toggleSection" />
        <div ref="filterSection"
            :class="isSectionActive ? 'tenjityModule-section-content tenjityModule-section-content-active' : 'tenjityModule-section-content'">
            <div class="tenjityModule-item" v-for="filter in filtersData" :key="filter.filterType"
                @click="toggleFilter(filter)" :class="{ 'tenjityModule-item-active': isActiveFilter(filter.name) }">
                <div class="tenjityModule-item-header">
                    <Icon class="tenjityModule-item-icon tenjityModule-item-icon-filter" :icon="filter.icon" />
                    <div class="tenjityModule-item-name-small" role="button">{{ filter.name }}</div>
                    <div class="tenjityModule-item-right"></div>
                </div>
                <div class="tenjityModule-item-btns">
                    <AccessibilityBtn type="minus" @handleClick="changeFilterValue(filter, 'minus')"
                        :isDisabled="filter.value === filter.min" />
                    <AccessibilityInput :label="filter.name" :min="filter.min" :max="filter.max" :unit="filter.unit"
                        @handleClickInput="checkToggleFilter(filter)" v-model:inputValue="filter.value" />
                    <AccessibilityBtn type="more" @handleClick="changeFilterValue(filter, 'more')"
                        :isDisabled="filter.value === filter.max" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccessibilityBtn from "./AccessibilityBtn.vue";
import AccessibilitySectionHeader from "./AccessibilitySectionHeader.vue";
import AccessibilityInput from "./AccessibilityInput.vue";
import { Icon } from "@iconify/vue";
export default {
    name: "AccessibilityFilters",
    components: {
        AccessibilityBtn,
        AccessibilitySectionHeader,
        AccessibilityInput,
        Icon,
    },
    props: {
        title: {
            type: String,
            default: "Teintes et luminosité",
        },
        profilFilters: {
            type: Array,
        },
        embedded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isSectionActive: this.embedded,
            filtersActive: [],
            filtersData: [
                {
                    filterType: "grayscale",
                    name: "Niveaux de gris",
                    min: 0,
                    max: 100,
                    step: 5,
                    value: 0,
                    unit: "%",
                    icon: "fluent:add-subtract-circle-48-regular",
                },
                {
                    filterType: "contrast",
                    name: "Contraste",
                    min: 5,
                    max: 400,
                    step: 5,
                    value: 100,
                    unit: "%",
                    icon: "fluent:add-subtract-circle-28-filled",
                },
                /*{
                    filterType: "sepia",
                    name: "Sépia",
                    min: 0,
                    max: 100,
                    step: 5,
                    value: 0,
                    unit: "%",
                    icon: "fluent:brightness-high-32-filled",
                },*/
                {
                    filterType: "saturate",
                    name: "Saturation",
                    min: 0,
                    max: 400,
                    step: 5,
                    value: 100,
                    unit: "%",
                    icon: "fluent:dark-theme-24-regular",
                },
                /*{
                    filterType: "opacity",
                    name: "Opacité",
                    min: 0,
                    max: 100,
                    step: 5,
                    value: 100,
                    unit: "%",
                    icon: "fluent:circle-half-fill-16-regular",
                },*/
                {
                    filterType: "brightness",
                    name: "Luminosité",
                    min: 5,
                    max: 400,
                    step: 5,
                    value: 100,
                    unit: "%",
                    icon: "fluent:brightness-high-32-regular",
                },
                /*{
                    filterType: "invert",
                    name: "Inversion",
                    min: 0,
                    max: 100,
                    step: 5,
                    value: 0,
                    unit: "%",
                    icon: "fluent:weather-moon-28-regular",
                },*/
            ],
        };
    },
    watch: {
        filtersActive: {
            handler: function (val) {
                this.$emit('filtersChange', val.map(f => ({ filterType: f.filterType, value: f.value })));
            },
            deep: true,
        },
        profilFilters: {
            handler() {
                this.resetData();
                if (this.profilFilters.length > 0) {
                    this.filtersActive = [];
                    this.profilFilters.forEach((profil) => {
                        const filter = this.filtersData.find((filter) => filter.filterType === profil.filterType);
                        if (filter) {
                            filter.value = profil.value;
                            this.filtersActive.push(filter);
                        }
                    });
                }
            },
        },
    },
    methods: {
        toggleFilter(filterObject) {
            const index = this.filtersActive.findIndex((filter) => filter.name === filterObject.name);
            if (index !== -1) {
                this.filtersActive.splice(index, 1);
            } else {
                this.filtersActive.push(filterObject);
            }
        },

        isActiveFilter(filterName) {
            return this.filtersActive.some((filter) => filter.name === filterName);
        },
        checkToggleFilter(filterObject) {
            const filter = this.filtersActive.find((filter) => filter.name === filterObject.name);
            if (!filter) {
                this.toggleFilter(filterObject);
            }
        },
        changeFilterValue(filterObject, type) {
            this.checkToggleFilter(filterObject);
            if (type === "minus") {
                if (filterObject.value === filterObject.min) return;
                filterObject.value = filterObject.value - filterObject.step;
            }

            if (type === "more") {
                if (filterObject.value === filterObject.max) return;
                filterObject.value = filterObject.value + filterObject.step;
            }
        },
        resetData() {
            this.filtersActive = [];
            this.filtersData.forEach(function (filter) {
                if (["contrast", "saturate", "opacity", "brightness"].includes(filter.filterType)) {
                    filter.value = 100;
                } else {
                    filter.value = 0;
                }
            });
        },
        toggleSection() {
            this.isSectionActive = !this.isSectionActive;
            if (this.isSectionActive) {
                this.$refs.filterSection.style.height = "auto";
            } else {
                this.$refs.filterSection.style.height = "0px";
            }
            this.$emit("handleToggleSection");
        },
    },
};
</script>
